export default __webpack_public_path__ + "static/media/flag-button-active@3x.fc98b25d.png";